import { render } from "./GlobalDermatology.vue?vue&type=template&id=a1ca64f2"
import script from "./GlobalDermatology.vue?vue&type=script&lang=js"
export * from "./GlobalDermatology.vue?vue&type=script&lang=js"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__